// Breadcrumbs.js

// Number of prior navigation steps shown in toolbar breadcrumbs.
export const NAVIGATION_BREADCRUMB_VISIBLE_STEPS = 3;

// Maximum in-memory trail length retained in navigation state.
export const NAVIGATION_BREADCRUMB_MAX_STEPS = 25;
